const $ = require('jquery'), transition = require('../../../common/components/transition/transition-events.js');

module.exports = function (categoriesService, $state, $timeout, specialsGroupsService, shopperService, breakpointsService, settingsService, settingsByBreakpoint, moveFocus, featureService, pageMetadataService) {
    return {
        restrict: 'E',
        scope: {},
        link(scope, element) {

            // Toggle behaviour
            scope.displayOptions = [{ text: 'Type' }, { text: 'Category' }];
            scope.shopper = shopperService;
            scope.breakpoints = breakpointsService;
            const isEnableSpecialTypeLandingPage = featureService.isEnabled(featureService.features.enableSpecialTypeLandingPage);

            function containRecency(sortTypes) {
                for (let i = 0; i < sortTypes.length; i++) {
                    if (sortTypes[i].Text === 'Recency') {
                        return true;
                    }
                }
                return false;
            }

            // Remove the 'Recency' option from the sorting list for category display type.
            function filterSortTypes() {
                settingsService.getSettingValue('Specials', 'SortOptions').then(function (sortTypes) {
                    if (containRecency(sortTypes)) {
                        sortTypes.pop();
                    }
                });
            }

            function update() {
                const shouldReloadIfViewSelected = scope.selectedDisplay.text !== scope.displayOptions[1].text && $state.includes('shop.specials.browse') && !breakpointsService.isInSmallFormat && isEnableSpecialTypeLandingPage;
                if (shouldReloadIfViewSelected) {
                    $state.go('shop.specials.landing', { aisle: null, category: null }).then(function () {
                        categoriesService.updateUrl();
                    });
                } else if (scope.selectedDisplay.text === scope.displayOptions[1].text) {
                    $state.go('shop.specials.browse', { aisle: null, category: null }).then(function () {
                        categoriesService.updateUrl();
                        filterSortTypes();
                    });
                } else if (breakpointsService.isInSmallFormat || !isEnableSpecialTypeLandingPage) {
                    specialsGroupsService.firstSpecialsGroupUrl();
                }
            }

            function updateScrollerFromUrl(isFirstLoad) {
                if (scope.isSmallFormat() && ((!$state.params.category && !$state.params.aisle) || !categoriesService.currentCategory.department)) {
                    return; // no scroll on url change in small format if the params are undefined
                }

                if ($state.is('shop.specials.browse.category.aisle') && !categoriesService.categoryExists(categoriesService.categories, $state.params.category, $state.params.aisle)) {
                    $state.go('shop.specials.browse');
                    return;
                }

                categoriesService.updateServiceState(scope.stateOptions, scope.landingOptions);

                if ($state.includes('shop.specials.browse') && !$state.params.category && !$state.params.aisle) {
                    categoriesService.updateUrl(false, isFirstLoad, true, undefined, scope.stateOptions, isFirstLoad);
                }

                $timeout(function () { //  wait the categories spinner to be in the view
                    scope.$broadcast('categories:change', { currentCategory: categoriesService.currentCategory, triggerScroll: isFirstLoad });
                }, 0, false);
            }

            function init() {
                categoriesService.getAll(true)
                    .then(function () {
                        scope.categoriesService = categoriesService;
                    })
                    .then(function () {
                        updateScrollerFromUrl(true);
                        scope.$on('$stateChangeSuccess', function () {
                            updateScrollerFromUrl(false);
                        });
                    });
            }

            function hidePanel(panelSelector) {
                // display both panels
                element.find('.specialsGroups, .categorySpinner').removeClass('u-displayNone');
                // hide the panels ou of screen after transition
                setTimeout(function () {
                    element.find(panelSelector).addClass('u-displayNone');
                }, 1000);
            }

            function displaySelectedPanel() {
                const isCategory = scope.selectedDisplay.text === scope.displayOptions[1].text;

                // Check if the selected option is the same as current
                const isSameSelection = $('.specialsGroups, .categorySpinner')
                    .filter(':visible')
                    .hasClass(isCategory ? 'categorySpinner' : 'specialsGroups');
                if (!isSameSelection) {
                    // Hide current panel, and show selected panel
                    hidePanel(isCategory ? '.specialsGroups' : '.categorySpinner');

                    // Wait till transition ends, then move focus so transition is smooth
                    transition.onTransitionEnd(element, function () {
                        moveFocus(isCategory ? '.categorySpinner' : '.specialsGroups');
                    });
                } else {
                    // No transition, so just move back to navigation panel
                    moveFocus(isCategory ? '.categorySpinner' : '.specialsGroups');
                }
            }

            function initPanels() {
                settingsService.getSettingValue('OneSite', 'DefaultPageToSpecialGroup')
                    .then(function (result) {
                        if ($state.is('shop.specials')) {
                            scope.selectedDisplay = scope.displayOptions[result === 'false' ? 1 : 0];
                        } else if ($state.includes('shop.specials.browse')) {
                            scope.selectedDisplay = scope.displayOptions[1];
                        } else {
                            scope.selectedDisplay = scope.displayOptions[0];
                        }
                    }).then(function () {
                        if (scope.selectedDisplay.text === scope.displayOptions[1].text) {
                            hidePanel('.specialsGroups');
                        } else {
                            hidePanel('.categorySpinner');
                        }
                    });
            }

            function resetPanels() {
                // get default scroller options from state data
                scope.selectedDisplay = scope.displayOptions[$state.$current.data.isScrollerOpen ? 1 : 0];
                initPanels();
                init();
            }

            function toggleDisplay() {
                if (scope.selectedDisplay.text === scope.displayOptions[0].text) {
                    scope.selectedDisplay = scope.displayOptions[1];
                } else {
                    scope.selectedDisplay = scope.displayOptions[0];
                }
                displaySelectedPanel();
            }

            initPanels();

            scope.stateOptions = {
                state: 'shop.specials.browse.category.aisle',
                category: 'category',
                subCategory: 'aisle'
            };

            scope.dropdownChange = function () {
                displaySelectedPanel();
                update();
            };

            scope.shouldShowTypes = function () {
                if (!scope.selectedDisplay) {
                    return false;
                }
                return scope.selectedDisplay.text === scope.displayOptions[0].text;
            };
            scope.shouldShowCategories = function () {
                return scope.selectedDisplay.text === scope.displayOptions[1].text;
            };

            scope.isSmallFormat = function () {
                return breakpointsService.isSmallFormat();
            };

            function collapsibleSpinnerEnabled() {
                return settingsByBreakpoint.getSettingValueByBreakpoint('VisualShopping',
                {
                    largeFormat: 'CollapseCategoriesInLargeFormat',
                    mediumFormat: 'CollapseCategoriesInMediumFormat',
                    smallFormat: 'CollapseCategoriesInSmallFormat'
                });
            }

            collapsibleSpinnerEnabled().then(function (enabled) {
                scope.useScrollingSpinner = !enabled;
                scope.useCollapsibleSpinner = enabled;
            });


            scope.$on('inlineCoaching-specials:toggleView', toggleDisplay);
            scope.$on('inlineCoaching-specials:end', resetPanels);
            scope.$on('categories:invalidated', init);
            scope.$on('$stateChangeStart', function (event, toState) {
                if (toState.name !== 'shop.specials.groupsv2' && toState.name !== 'shop.specials.groups' && toState.name !== 'shop.specials.landing') {
                    pageMetadataService.isNoIndexPage = false;
                }
            });
            init();
        },
        template: require('./specials-navigation-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/specials/specials-navigation-directive.js
 **/